module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@2x-3ab189ea39baf719acdaba56a3ffab24.png";